import React, { useState } from 'react';
import { Form, Field } from 'react-final-form';
import { TextField, Select, MenuItem, Button, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import FooterMenu from '../../component/layout/FooterMenu';
import swal from 'sweetalert'
import { useTranslation } from 'react-i18next';
import { useHistory } from "react-router-dom";

const FormBuilder = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [formFields, setFormFields] = useState([]);

  const addField = () => {
    setFormFields([
      ...formFields,
      {
        name: '',
        type: 'text',
        options: [],
      },
    ]);
  };

  const removeField = (index) => {
    const updatedFields = formFields.filter((_, i) => i !== index);
    setFormFields(updatedFields);
  };

  const handleFieldChange = (index, field) => {
    const updatedFields = [...formFields];
    updatedFields[index] = field;
    setFormFields(updatedFields);
  };

  const onSubmit = (values) => {
    console.log(values,formFields);
    swal({
        title: t("Success"),
        text: t("Data saved successfully"),
        icon: "success",
        button: t("Close"),
    })
    .then(res => {
        history.push('/layout/home')
    })
    // You can perform any actions with the form values here
  };

  return (
    <div className="form-builder main-container">
      <FooterMenu></FooterMenu>
      {/* <h2>Add New Disease</h2> */}
      <p class="alertformheading">Add New Disease</p>
      <br/>
      <Form onSubmit={onSubmit}>
        {({ handleSubmit, form,values }) => (
          <form onSubmit={handleSubmit}>
            <div className="form-field">
                <TextField
                    label="New Disease Name"
                    name={"disease-name"}
                    hiddenLabel
                    size="small"
                    style={{paddingTop:"0px"}}
                />
            </div>
            <br/>
            {formFields.map((field, index) => (
              <div key={index} className="form-field">
                <TextField
                  label="Field Name"
                  value={field.name}
                  onChange={(e) =>
                    handleFieldChange(index, { ...field, name: e.target.value })
                  }
                />

                <FormControl>
                  <FormLabel>Field Type</FormLabel>
                  <Select
                    value={field.type}
                    onChange={(e) =>
                      handleFieldChange(index, { ...field, type: e.target.value })
                    }
                  >
                    <MenuItem value="text">Text</MenuItem>
                    <MenuItem value="number">Number</MenuItem>
                    <MenuItem value="select">Select</MenuItem>
                    <MenuItem value="radio">Radio</MenuItem>
                  </Select>
                </FormControl>

                {field.type === 'select' || field.type === 'radio' ? (
                  <div className="options">
                    {field.options.map((option, optionIndex) => (
                      <div key={optionIndex}>
                        <TextField
                          label={`Option ${optionIndex + 1} Label`}
                          value={option.label}
                          onChange={(e) => {
                            const updatedOptions = [...field.options];
                            updatedOptions[optionIndex] = {
                              ...option,
                              label: e.target.value,
                            };
                            handleFieldChange(index, {
                              ...field,
                              options: updatedOptions,
                            });
                          }}
                        />

                        <TextField
                          label={`Option ${optionIndex + 1} Value`}
                          value={option.value}
                          onChange={(e) => {
                            const updatedOptions = [...field.options];
                            updatedOptions[optionIndex] = {
                              ...option,
                              value: e.target.value,
                            };
                            handleFieldChange(index, {
                              ...field,
                              options: updatedOptions,
                            });
                          }}
                        />

                        <Button
                          style={{border: "1px solid"}}
                          onClick={() => {
                            const updatedOptions = [...field.options];
                            updatedOptions.splice(optionIndex, 1);
                            handleFieldChange(index, {
                              ...field,
                              options: updatedOptions,
                            });
                          }}
                        >
                          Remove Option
                        </Button>
                      </div>
                    ))}

                    <Button
                      style={{border: "1px solid"}} 
                      onClick={() =>
                        handleFieldChange(index, {
                          ...field,
                          options: [
                            ...field.options,
                            { label: '', value: '' },
                          ],
                        })
                      }
                    >
                      Add Option
                    </Button>
                  </div>
                ) : null}

                <Button
                  onClick={() => removeField(index)}
                  className="remove-button"
                  startIcon={<RemoveIcon />}
                  style={{border: "1px solid"}}
                >
                  Remove
                </Button>
              </div>
            ))}

            <Button
              onClick={addField}
              startIcon={<AddIcon />}
              className="add-button fill-button"
            >
              Add Field
            </Button>

            <Button primary type="submit" className='fill-button'>
              Submit
            </Button>
          </form>
        )}
      </Form>
    </div>
  );
};

export default FormBuilder;
